import {
  Button,
  ButtonColor,
  type ButtonProps,
  ButtonWidth,
  DateFormat,
  formatDate,
  formatTime,
  IconX,
} from '@leland-dev/leland-ui-library';
import React, { type FC } from 'react';

export interface AdditionalAction {
  label: string;
  onClick: () => void;
}

interface ScheduleModalFooterProps {
  selectedTime: Possible<number>;
  setSelectedTime: (time: Possible<number>) => void;
  buttonProps?: Partial<ButtonProps>;
  additionalActions?: Possible<AdditionalAction[]>;
  onBackClick?: () => void;
  showSelectedTime: boolean;
  showBackButton: boolean;
}

export const ScheduleModalFooter: FC<ScheduleModalFooterProps> = ({
  selectedTime,
  setSelectedTime,
  buttonProps,
  additionalActions,
  onBackClick,
  showSelectedTime,
  showBackButton,
}) => {
  const includeBackButton = showBackButton && onBackClick;
  return (
    <div
      className={`flex w-full flex-col gap-2 bg-leland-white p-2 md:static md:flex-row md:items-center ${includeBackButton ? 'justify-between' : 'justify-end'}`}
    >
      {includeBackButton ? (
        <Button
          buttonColor={ButtonColor.WHITE}
          width={ButtonWidth.FULL_MOBILE}
          label="Back"
          onClick={onBackClick}
        />
      ) : null}
      {showSelectedTime && selectedTime ? (
        <div className="flex grow flex-col items-start md:flex-row md:items-center">
          <span className="text-lg font-medium text-leland-gray-dark">
            Selected time:
          </span>
          <div className="mb-4 mt-2 inline-flex items-center rounded-md border border-leland-blue p-3 font-medium text-leland-blue md:my-0 md:ml-4">
            <span>
              {formatDate(selectedTime, DateFormat.LONG_MONTH_DAY)} at{' '}
              {formatTime(selectedTime)}
            </span>
            <IconX
              className="ml-1 size-5 cursor-pointer rounded p-1 hover:bg-leland-gray-hover"
              onClick={() => {
                setSelectedTime(null);
              }}
            />
          </div>
        </div>
      ) : showSelectedTime ? (
        <span className="mb-4 grow text-lg font-medium text-leland-gray-extra-light md:mb-0">
          No time slot selected
        </span>
      ) : null}
      <div className="flex">
        {additionalActions?.map(({ label, onClick }, idx) => (
          <button
            key={idx}
            className="mr-2 text-leland-gray-light underline underline-offset-2"
            onClick={onClick}
          >
            {label}
          </button>
        ))}
        <Button
          buttonColor={ButtonColor.PRIMARY}
          label="Continue" // default label
          width={ButtonWidth.FULL_MOBILE}
          {...buttonProps}
        />
      </div>
    </div>
  );
};
